import { JSX } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, Layout } from '../../../components/core';
import { FormErrorSubmit, FormInput } from '../../../components/form';

type ActivationResendFormProps = {
  onSuccess: (newUserEmail: string) => void;
};

export const ActivationResendForm = ({ onSuccess }: ActivationResendFormProps): JSX.Element => {
  const formContext = useForm({
    defaultValues: {
      email: '',
      submit: undefined,
    },
  });

  const loading = false;
  const resendActivation = (props: { email: string }): void => {
    onSuccess(props.email);
  };
  // const [resendActivation, { loading }] = useResendActivationEmailMutation({
  //   onCompleted: ({ resendActivationEmail }): void => {},
  //   onError: authError => {
  //     if (isRateLimited(authError)) {
  //       // TODO: What message should we show here?
  //       formContext.setError(
  //         'submit',
  //         new Error('Your account has been locked. Please wait 15 minutes before trying again.'),
  //       );
  //       return;
  //     }
  //
  //     formContext.setError('submit', authError);
  //   },
  // });

  const {
    clearErrors,
    control,
    handleSubmit,
    formState: { errors },
  } = formContext;

  const submitForm = (): void => {
    // Make sure to clear the errors first, or any submit errors will prevent form submission.
    clearErrors();

    void handleSubmit(async ({ email }): Promise<void> => {
      await resendActivation({ email });
    })();
  };

  return (
    <FormProvider {...formContext}>
      <Layout.VStack space={6}>
        <Layout.View>
          <FormInput
            label="Email address"
            name="email"
            placeholder="School email address"
            autoCapitalize="none"
            autoFocus
            isRequired
            rules={{ pattern: { value: /.+@.+\..+/, message: 'You must enter a valid email.' } }}
            control={control}
            error={errors.email}
            keyboardType="email-address"
            onSubmitEditing={submitForm}
          />

          {errors.submit && (
            <FormErrorSubmit marginTop={6}>{errors.submit.message}</FormErrorSubmit>
          )}
        </Layout.View>

        <Layout.VStack>
          <Button.primaryMedium
            isDisabled={loading}
            testID="button-activation-resend-submit"
            onPress={submitForm}
          >
            Send
          </Button.primaryMedium>
        </Layout.VStack>
      </Layout.VStack>
    </FormProvider>
  );
};
